export default __webpack_public_path__ + "static/media/7 - Парки на месте бывших промзон.b2b3aa03.jpg";